'use strict';

var selectItemEvent = require('./components/GAevents/selectItemEvent');
/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
function getEinsteinUtils() {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === 'function') && (typeof einsteinUtils.getCQCookieId === 'function')) {
        return einsteinUtils;
    }
    return null;
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function fillDomElement(einsteinResponse, $parentElement) {
    var recommender = $parentElement.data('recommender');
    
    if (recommender === 'manual') {
        return;
    }
    
    var recommendedProducts = einsteinResponse[recommender] && einsteinResponse[recommender].recs;

    if (recommendedProducts && recommendedProducts.length > 0) {
        var template = $parentElement.data('template');
        var manualProducts = $parentElement.data('manual-products');
        var swatches = $parentElement.data('swatches');
        var displayRatings = $parentElement.data('displayratings');
        var components = [];

        if (manualProducts) {
            var manualProductIds = manualProducts.replace(/\s/g, '').split(',');

            var manualProductsModel = manualProductIds.map(function(productId) {
                return {
                    classxs: $parentElement.data('bsxs'),
                    classsm: $parentElement.data('bssm'),
                    classmd: $parentElement.data('bsmd'),
                    template: template,
                    swatches: swatches,
                    displayratings: displayRatings,
                    model: {
                        type: 'product',
                        id: productId
                    }
                };
            });
            
            components = components.concat(manualProductsModel);
        }

        var einsteinRecommendedProductsModel = recommendedProducts.map(function (recommendedProduct) {
            var tiledefinition = {};
            tiledefinition.classxs = $parentElement.data('bsxs');
            tiledefinition.classsm = $parentElement.data('bssm');
            tiledefinition.classmd = $parentElement.data('bsmd');
            tiledefinition.template = template;
            tiledefinition.swatches = swatches;
            tiledefinition.displayratings = displayRatings;
            tiledefinition.model = {
                type: 'product',
                id: recommendedProduct.id
            };
            return tiledefinition;
        });

        components = components.concat(einsteinRecommendedProductsModel);

        var url = new URL($parentElement.data('product-load-url'));
        url.searchParams.append('components', JSON.stringify(components));
        url.searchParams.append('limit', components.length);
        url.searchParams.append('recommender', recommender);
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                $parentElement.find('.swiper-inner').append(html);
                selectItemEvent.initSelectItemEvent();
                if ($('html').hasClass('ua-desktop')) {
                    var totalProducts = $parentElement.find('.swiper-slide').length;
                    if (totalProducts <= 5) {
                        $parentElement.find('.swiper-einstein-prev, .swiper-einstein-next').hide();
                    }
                }
            },
            error: function () {
                $parentElement.spinner().stop();
            }
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
 */
function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
    var recommender = $parentElement.data('recommender');

    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
    * Processes a recommendation responses
    * @param {Object} einsteinResponse cquotient object
    */
    function recommendationsReceived(einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement);
        $parentElement.spinner().stop();
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createProductAnchor($parentElement) {
    var anchorID = $parentElement.data('anchorId'); 
    if (anchorID) {
        return [{
            id: anchorID,
            type: 'pid'
        }];
    }

    return [{
        id: $parentElement.data('primaryProductId'),
        sku: $parentElement.data('secondaryProductId'),
        type: $parentElement.data('alternativeGroupType'),
        alt_id: $parentElement.data('alternativeGroupId')
    }];
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
    return [{ id: $parentElement.data('categoryId') }];
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadRecommendations() {
    $('.carousel[data-recommender="manual"]').each(function() {
        var $parentElement = $(this);
        
        if ($parentElement.data('isEinsteinDisabled') === true) {
            return;
        }
    });
    
    
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var $recommendationTiles = $('.einstein-carousel');
        $recommendationTiles.each(function () {
            var $parentElement = $(this);

            if ($parentElement.data('isEinsteinDisabled') === true || $parentElement.data('recommender') === 'manual') {
                return;
            }

            $parentElement.spinner().start();
            if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            } if ($(this).closest('.experience-commerce_advanced_custom-mostSearchedCarousel').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            } if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
            } if ($(this).closest('.experience-commerce_advanced_custom-einsteinCarouselCategory').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
            } if ($parentElement.data('anchorId')) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            }
            return processRecommendationsTile($parentElement, einsteinUtils);
        });
    }
}

var processInclude = require('base/util');

$(document).ready(function () {
    loadRecommendations();
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
});